// Angular + external
import {
  ComponentFactoryResolver,
  Injectable,
  ViewContainerRef,
  ComponentRef,
  Type,
  OnDestroy,
} from "@angular/core";
import { Subscription } from "rxjs";
// BFX
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxDialogCommand } from "../models/bfx-dialog-command.enum";
import { BfxDialogData } from "../models/bfx-dialog-data.model";
import { BfxDialogBaseComponent } from "../bfx-dialog-base.component";
import { DashboardItemType } from "../../bfx-common/models/dashboard-item-type.enum";
// Components
import { BfxDialogExportComponent } from "../bfx-dialog-export.component";
import { BfxDialogFilterCopyComponent } from "../bfx-dialog-filter-copy.component";
import { BfxDialogFilterNewComponent } from "../bfx-dialog-filter-new.component";
import { BfxDialogFilterDeleteComponent } from "../bfx-dialog-filter-delete.component";
import { BfxDialogOpsIntClearConfirmComponent } from "../bfx-dialog-ops-int-clear-confirm.component";
// order
import { BfxDialogOrderQuickFillConfirmComponent } from "../bfx-dialog-order-quick-fill-confirm.component";
import { BfxDialogOrderQuickFillWarningComponent } from "../bfx-dialog-order-quick-fill-warning.component";
import { BfxDialogOrderAcceptIntoComponent } from "../bfx-dialog-order-accept-into.component";
import { BfxDialogOrderCancelWarningComponent } from "../bfx-dialog-order-cancel-warning.component";
import { BfxDialogOrderCancelConfirmComponent } from "../bfx-dialog-order-cancel-confirm.component";
import { BfxDialogConfirmComponent } from "../bfx-dialog-confirm.component";
import { BfxDialogOrderDetailFillWarningComponent } from "../bfx-dialog-order-detail-fill-warning.component";

// trade
import { BfxDialogTradeCancelConfirmComponent } from "../bfx-dialog-trade-cancel-confirm.component";
import { BfxDialogTradeAddFillCommentComponent } from "../bfx-dialog-trade-add-fill-comment.component";

// Services
import { BfxConfigService } from "../../../shared/auth-services/system-config/bfx-config.service";
import { BfxAuthService } from "../../bfx-common/services/bfx-auth.service";
import { BfxBlotterOrdersActionService } from "../../bfx-blotter-orders/bfx-blotter-orders-action.service";
import { BfxTradeActionsService } from "../../bfx-blotter-trade/services/bfx-trade-actions.service";
import { BfxInterventionActionsService } from "../../bfx-blotter-intervention/services/bfx-intervention-actions.service";
import { BfxBlotterFilterService } from "../../bfx-blotter-filter/bfx-blotter-filter.service";
import { BfxFindDealsService } from "../../bfx-find-deals/bfx-find-deals.service";
import { BfxFindOrdersService } from "../../bfx-find-orders/bfx-find-orders.service";
import { BfxDialogFindNewFavoriteComponent } from "../bfx-dialog-find-new-favorite.component";
import { BfxDialogOKComponent } from "../bfx-dialog-ok.component";
import { BfxDialogReconnectComponent } from "../bfx-dialog-reconnect.component";
import { BfxDialogRestartComponent } from "../bfx-dialog-restart.component";
import { BfxDetailFillService } from "../../bfx-detail-fill/services/bfx-detail-fill.service";
import {
  GoldenLayoutService,
  GLPopoutConfiguration,
  GLPopoutState,
  GLPopoutUndockBehaviour,
} from "../../golden-layout/golden-layout-service";
import { GoldenLayoutAdditionMode } from "../../golden-layout/golden-layout-addition-mode";
import { TranslateService } from "@ngx-translate/core";
import { BfxDialogToleranceComponent } from "../bfx-dialog-tolerance.component";
import { BfxSystemMessageService } from "app/bfx-common/services/bfx-system-message.service";
import { BfxReconnectDialogService } from "app/bfx-common/services/bfx-reconnect-dialog.service";
import { OEDialogService } from "app/order-entry/services/basic/oe-dialogs.service";
import { BFXLogoutWarningService } from "app/bfx-common/services/bfx-logout-warnings.service";
import { BfxDialogPublicProfileSaveComponent } from "../bfx-dialog-public-profile-save.component";
import { BfxPublicProfileService } from "../../bfx-common/services/bfx-public-profile.service";
import { BfxScratchPadService } from "../../bfx-blotter-scratchpad/services/bfx-scratchpad.service";
import { BfxHedgeOrderMonitorComponent } from "app/bfx-hedge-order-monitor/bfx-hedge-order-monitor.component";
import { BfxBmarkHedgeOrdersBlotterActionsService } from "app/bfx-bmark-summary/blotters/hedge-orders/services/bmark-hedge-orders-actions.service";
import { BfxBmarkClientOrdersBlotterActionsService } from "app/bfx-bmark-summary/blotters/client-orders/services/bmark-client-orders-actions.service";
import { BfxBlotterOpsIntActionsService } from "app/bfx-blotter-ops-int/services/bfx-blotter-ops-int-actions.service";
import { LoggerService } from "@bfx/logger";
import { BfxDashboardMenuService } from "../../bfx-common/services/bfx-dashboard-menu.service";
import { BfxDialogOKCancelComponent } from "../bfx-dialog-ok-cancel.component";
import { FwdRollPricingService } from "app/bfx-blotter-intervention/fwd-roll-pricing/services/fwd-roll-pricing.service";
import { BfxDialogFwdRollReplaceComponent } from "app/bfx-dialogs/bfx-dialog-fwd-roll-replace";
import { BfxAutoHedgeStatusChangeComponent } from "../bfx-dialog-auto-hedge-status-change.component";
import { BfxDialogChangePasswordComponent } from "app/bfx-dialogs/bfx-dialog-change-password";
import { BmarkSpotRiskContextMenuService } from "app/bfx-bmark-summary/blotters/spot-risk/services/bmark-spot-risk-context-menu.service";
import { BfxOrderFillNowComponent } from "app/bfx-order-fill-now/bfx-order-fill-now.component";
import { BfxOrderFillNowService } from "app/bfx-order-fill-now/services/bfx-order-fill-now.service";
import { BfxDialogSwitchProfileComponent } from "app/bfx-dialogs/bfx-dialog-switch-profile.component";
import { ManualPricingManagerService } from "app/bfx-blotter-intervention/manual-pricing/services/manual-pricing-manager.service";
import { BmarkFwdRiskContextMenuService } from "app/bfx-bmark-summary/blotters/spot-risk/services/bmark-fwd-risk-context-menu.service";

const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxDialogsCoordinatorService implements OnDestroy {
  /**********************************************************************/
  /* DATA */
  private rootViewContainer: ViewContainerRef;
  private dialogCounter = 0;
  private config: any = {
    debug: false,
  };

  private dialogsMap: Map<string, ComponentRef<BfxDialogBaseComponent>> = new Map();
  private dialogSubscriptionMap: Map<string, Subscription> = new Map();

  private configurationSubscription: Subscription;
  private orderActionSubscription: Subscription;
  private tradeActionSubscription: Subscription;
  private interventionActionSubscription: Subscription;
  private authSubscription: Subscription;
  private systemMessageSubscription: Subscription;
  private filterActionSubscription: Subscription;
  private orderEntrySubscription: Subscription;
  private detailFillSubscription: Subscription;
  private logoutWarningSubscription: Subscription;
  private publicProfileActionSubscription: Subscription;
  private scratchPadActionsSubscription: Subscription;
  private hedgeOrderMonitorSubscription: Subscription;
  private hedgeOrderActionsSubscription: Subscription;
  private clientOrderActionsSubscription: Subscription;
  private opsIntActionSubscription: Subscription;
  private popupNotificationSubscription: any;
  private fwdRollActionSubscription: Subscription;
  private manualPricingActionSubscription: Subscription;
  private fillNowSubscription: Subscription;
  changePasswordSubscription: Subscription;
  private spotRiskActionsSubscription: Subscription;
  private fwdRiskActionsSubscription: Subscription;
  private goldenLayoutSubscription: Subscription;

  /**********************************************************************/
  /* CONSTRUCTOR  */
  constructor(
    private _configService: BfxConfigService,
    private factoryResolver: ComponentFactoryResolver,
    private _orderActionsService: BfxBlotterOrdersActionService,
    private _tradeActionsService: BfxTradeActionsService,
    private _interventionActionsService: BfxInterventionActionsService,
    private _authService: BfxAuthService,
    private _findDealsServices: BfxFindDealsService,
    private _findOrdersServices: BfxFindOrdersService,
    private _filterServices: BfxBlotterFilterService,
    private _oeDialogs: OEDialogService,
    private detailFillService: BfxDetailFillService,
    private layoutService: GoldenLayoutService,
    private translationService: TranslateService,
    private _systemMessageService: BfxSystemMessageService,
    private _reconnectDialogService: BfxReconnectDialogService,
    private _logoutWarningService: BFXLogoutWarningService,
    private _bfxPublicProfileService: BfxPublicProfileService,
    private _scratchpadService: BfxScratchPadService,
    private _hedgeOrderActionsService: BfxBmarkHedgeOrdersBlotterActionsService,
    private _clientOrderActionsService: BfxBmarkClientOrdersBlotterActionsService,
    private _opsIntActionsService: BfxBlotterOpsIntActionsService,
    private _dashboardMenuService: BfxDashboardMenuService,
    private _fwdRollPricingService: FwdRollPricingService,
    private _manualPricingManagerService: ManualPricingManagerService,
    private _spotRiskMenuService: BmarkSpotRiskContextMenuService,
    private _fwdRiskMenuService: BmarkFwdRiskContextMenuService,
    private _fillNowService: BfxOrderFillNowService,
  ) {
    this.initializeSubscriptions();
  }

  ngOnDestroy() {
    this.terminateSubscriptions();
    this.closeAllDialogs();
  }

  /**********************************************************************/
  /* INITIALIZATION */

  public setRootViewContainerRef(viewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  private initializeSubscriptions(): void {
    this.subscribeToGoldenLayout();
    this.subscribeToConfiguration();
    this.subscribeToAuth();
    this.subscribeToOrderBlotterActions();
    this.subscribeToTradeBlotterActions();
    this.subscribeToInterventionBlotterActions();
    this.subscribeToFindActions();
    this.subscribeToFilterActions();
    this.subscribeToOrderEntry();
    this.subscribeToDetailFillActions();
    this.subscribeToSystemMessage();
    this.subscribeToConnectionStatus();
    this.subscribeToLogoutWarningActions();
    this.subscribeToPublicProfileAction();
    this.subscribeToImportDilaogSubscription();
    this.subscribeToHedgeOrderMonitor();
    this.subscribeToHedgeOrderBlotterActions();
    this.subscribeToClientOrderBlotterActions();
    this.subscribeToOpsIntActions();
    this.subscribeToPopupNotificationServiceActions();
    this.subscribeToSpotRiskBlotterActions();
    this.subscribeToFwdRiskBlotterActions();
  }

  private terminateSubscriptions(): void {
    try {
      this.goldenLayoutSubscription.unsubscribe();
      this.configurationSubscription.unsubscribe();
      this.orderActionSubscription.unsubscribe();
      this.tradeActionSubscription.unsubscribe();
      this.orderActionSubscription.unsubscribe();
      this.interventionActionSubscription.unsubscribe();
      this.fwdRollActionSubscription.unsubscribe();
      this.manualPricingActionSubscription.unsubscribe();
      this.filterActionSubscription.unsubscribe();
      this.orderEntrySubscription.unsubscribe();
      this.detailFillSubscription.unsubscribe();
      this.logoutWarningSubscription.unsubscribe();
      this.publicProfileActionSubscription.unsubscribe();
      this.scratchPadActionsSubscription.unsubscribe();
      this.hedgeOrderMonitorSubscription.unsubscribe();
      this.hedgeOrderActionsSubscription.unsubscribe();
      this.clientOrderActionsSubscription.unsubscribe();
      this.opsIntActionSubscription.unsubscribe();
      this.changePasswordSubscription.unsubscribe();
      this.spotRiskActionsSubscription.unsubscribe();
      this.fwdRiskActionsSubscription.unsubscribe();
      this.fillNowSubscription.unsubscribe();
    } catch (ex) {
      logger.out.error(
        "dialco-s: BfxDialogsCoordinatorService.terminateSubscriptions(): Exception:",
        ex,
      );
    }
  }

  private subscribeToGoldenLayout(): void {
    this.goldenLayoutSubscription = this.layoutService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }
  private subscribeToOrderBlotterActions(): void {
    this.orderActionSubscription = this._orderActionsService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
    this.fillNowSubscription = this._fillNowService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToLogoutWarningActions(): void {
    this.logoutWarningSubscription = this._logoutWarningService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToDetailFillActions(): void {
    this.detailFillSubscription = this.detailFillService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToFindActions(): void {
    this.filterActionSubscription = this._findDealsServices.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );

    this.filterActionSubscription = this._findOrdersServices.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToFilterActions(): void {
    this.filterActionSubscription = this._filterServices.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToTradeBlotterActions(): void {
    this.tradeActionSubscription = this._tradeActionsService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToInterventionBlotterActions(): void {
    this.interventionActionSubscription = this._interventionActionsService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
    this.fwdRollActionSubscription = this._fwdRollPricingService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
    this.manualPricingActionSubscription = this._manualPricingManagerService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToSpotRiskBlotterActions(): void {
    this.spotRiskActionsSubscription = this._spotRiskMenuService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }
  private subscribeToFwdRiskBlotterActions(): void {
    this.fwdRiskActionsSubscription = this._fwdRiskMenuService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }
  private subscribeToHedgeOrderBlotterActions(): void {
    this.hedgeOrderActionsSubscription = this._hedgeOrderActionsService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToClientOrderBlotterActions(): void {
    this.clientOrderActionsSubscription = this._clientOrderActionsService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToConfiguration(): void {
    this.configurationSubscription = this._configService.uiConfig$.subscribe((config) => {
      this.config.debug = config.general.debug;
    });
  }

  private subscribeToConnectionStatus(): void {
    this._reconnectDialogService.reconnect$.subscribe((dialogData: BfxDialogData) => {
      this.dialogCommandHandler(dialogData);
    });
  }

  private subscribeToAuth(): void {
    this.authSubscription = this._authService.authStatus$.subscribe((status: boolean) => {
      if (!status) {
        // user is logged out
        this.closeAllDialogs();
      }
    });
    this.changePasswordSubscription = this._authService.changePassword$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToOrderEntry(): void {
    this.orderEntrySubscription = this._oeDialogs.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToSystemMessage(): void {
    this.systemMessageSubscription = this._systemMessageService.restart$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToPublicProfileAction(): void {
    this.publicProfileActionSubscription = this._bfxPublicProfileService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToImportDilaogSubscription(): void {
    this.scratchPadActionsSubscription = this._scratchpadService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToHedgeOrderMonitor(): void {
    this.hedgeOrderMonitorSubscription = BfxHedgeOrderMonitorComponent.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  private subscribeToOpsIntActions(): void {
    this.opsIntActionSubscription = this._opsIntActionsService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  subscribeToPopupNotificationServiceActions() {
    this.popupNotificationSubscription = this._dashboardMenuService.dialogCtrl$.subscribe(
      (dialogData: BfxDialogData) => {
        this.dialogCommandHandler(dialogData);
      },
    );
  }

  /**********************************************************************/
  /* MAIN */

  private dialogCommandHandler(_dialogData: BfxDialogData): void {
    if (!_dialogData) {
      logger.out.error(`dialco-s: No dialog data provided`);
      return;
    }

    logger.out.debug(
      `dialco-s: Processing dialog command ${BfxDialogCommand[_dialogData.command]}, id: ${_dialogData.dialogId}`,
    );
    let dialogId: string = _dialogData.dialogId;
    switch (_dialogData.command) {
      case BfxDialogCommand.AUTO_HEDGE_STATUS_CHANGE: {
        dialogId = this.doAutoHedgeStatusChangeDialog(dialogId, _dialogData);
        break;
      }
      /* Order Quick Fill Confirm */
      case BfxDialogCommand.DIALOG_ORDER_QUICK_FILL_CONFIRM_OPEN: // dialogId NOT needed
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("oqfc-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogOrderQuickFillConfirmComponent>(
            BfxDialogOrderQuickFillConfirmComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      /* Order Quick Fill Warning */
      case BfxDialogCommand.DIALOG_ORDER_QUICK_FILL_WARNING_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("oqfw-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogOrderQuickFillWarningComponent>(
            BfxDialogOrderQuickFillWarningComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      /* Order Detail Fill Confirm */
      case BfxDialogCommand.DIALOG_ORDER_DETAIL_FILL_CONFIRM_OPEN: // dialogId NOT needed
        let selectedItems: Array<CubiqTS.OrderDataImpl> = _dialogData.event.selectedItems;
        this.detailFillService.lockOrdersForFill(selectedItems).then((openDetailFill) => {
          if (openDetailFill) {
            let title: string = this.translationService.instant("detail.fill.title");

            let config: GLPopoutConfiguration = new GLPopoutConfiguration();

            config.initialState = GLPopoutState.POPOUT;
            config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
            config.popoutResizable = true;
            config.preferredSize = {
              width: Math.min(1400, window.innerWidth - 50),
              height: 345,
            };
            config.minimumSize = { width: 780, height: 345 };
            config.data = {};
            config.sourceEvent = _dialogData.event.sourceEvent;

            this.layoutService.launchFromDashboard(
              title,
              DashboardItemType.DetailFill,
              true,
              GoldenLayoutAdditionMode.DEFAULT,
              config,
            );
          }
        });
        break;

      /* Order Detail Fill Warning */
      case BfxDialogCommand.DIALOG_ORDER_DETAIL_FILL_WARNING_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("odfw-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogOrderDetailFillWarningComponent>(
            BfxDialogOrderDetailFillWarningComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      /* Order Accept Into */
      case BfxDialogCommand.DIALOG_ORDER_ACCEPT_INTO_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("oai-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogOrderAcceptIntoComponent>(
            BfxDialogOrderAcceptIntoComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      /* Trade Cancel Confirm */
      case BfxDialogCommand.DIALOG_TRADE_CANCEL_CONFIRM_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("tcc-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogTradeCancelConfirmComponent>(
            BfxDialogTradeCancelConfirmComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      /* Trade Add Fill Comment */
      case BfxDialogCommand.DIALOG_TRADE_ADD_FILL_COMMENT_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("tafc-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogTradeAddFillCommentComponent>(
            BfxDialogTradeAddFillCommentComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      /* Ops Int Clear */
      case BfxDialogCommand.DIALOG_OPS_INT_CONFIRM_CLEAR:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("oicc-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogOpsIntClearConfirmComponent>(
            BfxDialogOpsIntClearConfirmComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      /* CSV Export */
      case BfxDialogCommand.DIALOG_CSV_EXPORT_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("csve-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogExportComponent>(BfxDialogExportComponent),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;
      /* Find New Favorite */
      case BfxDialogCommand.DIALOG_FIND_NEW_FAVORITE:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("find-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogFindNewFavoriteComponent>(
            BfxDialogFindNewFavoriteComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;
      /* Filter Copy */
      case BfxDialogCommand.DIALOG_FILTER_COPY_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("filc-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogFilterCopyComponent>(
            BfxDialogFilterCopyComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      /* Filter New */
      case BfxDialogCommand.DIALOG_FILTER_NEW_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("filn-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogFilterNewComponent>(BfxDialogFilterNewComponent),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      /* Filter Delete */
      case BfxDialogCommand.DIALOG_FILTER_DELETE_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("fild-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogFilterDeleteComponent>(
            BfxDialogFilterDeleteComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      case BfxDialogCommand.DIALOG_ORDER_CANCEL_WARNING_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("ccbo-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogOrderCancelWarningComponent>(
            BfxDialogOrderCancelWarningComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      case BfxDialogCommand.DIALOG_ORDER_CANCEL_CONFIRM_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("ccco-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogOrderCancelConfirmComponent>(
            BfxDialogOrderCancelConfirmComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      /* Dealer Intervention Fwd Roll Replace */
      case BfxDialogCommand.DIALOG_FWD_ROLL_SAVE_ABORT_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("cfrr-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogFwdRollReplaceComponent>(
            BfxDialogFwdRollReplaceComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;
      case BfxDialogCommand.DIALOG_CHANGE_PASSWORD_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("ccpo-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogChangePasswordComponent>(
            BfxDialogChangePasswordComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;
      case BfxDialogCommand.DIALOG_GENERIC_WARN_OPEN:
      case BfxDialogCommand.DIALOG_GENERIC_CONFIRM_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("cgcd-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogConfirmComponent>(BfxDialogConfirmComponent),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      case BfxDialogCommand.DIALOG_GENERIC_OK:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("cgok-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogOKComponent>(BfxDialogOKComponent),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;
      case BfxDialogCommand.DIALOG_GENERIC_OK_CANCEL:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("cgsv-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogOKCancelComponent>(BfxDialogOKCancelComponent),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;
      case BfxDialogCommand.DIALOG_RECONNECT_CONFIRM:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("cgre-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogReconnectComponent>(BfxDialogReconnectComponent),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      case BfxDialogCommand.DIALOG_RESTART_CONFIRM:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("cgrc-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogRestartComponent>(BfxDialogRestartComponent),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      case BfxDialogCommand.DIALOG_ORDER_FILL_TOLERANCE_WARNING_OPEN:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("tol-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogToleranceComponent>(BfxDialogToleranceComponent),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      case BfxDialogCommand.DIALOG_ORDER_FILL_FAIL:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("ffl-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogOKComponent>(BfxDialogOKComponent),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;

      /* Public profile */
      case BfxDialogCommand.DIALOG_PUBLIC_PROFILE_SAVE:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("pfs-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogPublicProfileSaveComponent>(
            BfxDialogPublicProfileSaveComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;
      /* Switch profile */
      case BfxDialogCommand.DIALOG_SWITCH_PROFILE:
        dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("swp-");
        this.dialogsMap.set(
          dialogId,
          this.injectOrderDialogComponent<BfxDialogSwitchProfileComponent>(
            BfxDialogSwitchProfileComponent,
          ),
        );
        this.openDialogAttachSubscription(dialogId, _dialogData);
        break;
      /* case BfxDialogCommand.DIALOG_ORDER_ENTRY_CONFIRM_ABORT_OPEN:
				dialogId = 'oecd-' + ++this.dialogCounter;
				this.dialogsMap.set(dialogId, this.injectOrderDialogComponent<BfxDialogConfirmComponent>(BfxDialogConfirmComponent));
				this.openDialogAttachSubscription(dialogId, _dialogData);
				break;

			case BfxDialogCommand.DIALOG_MODIFY_CONFIRM_ABORT_OPEN:
				dialogId = 'mocd-' + ++this.dialogCounter;
				this.dialogsMap.set(dialogId, this.injectOrderDialogComponent<BfxDialogConfirmComponent>(BfxDialogConfirmComponent));
				this.openDialogAttachSubscription(dialogId, _dialogData);
				break;	 */

      /* CLOSE DIALOGS - External */
      case BfxDialogCommand.DIALOG_ORDER_QUICK_FILL_CONFIRM_CLOSE: // dialogId IS needed
      case BfxDialogCommand.DIALOG_ORDER_QUICK_FILL_WARNING_CLOSE:
      case BfxDialogCommand.DIALOG_ORDER_DETAIL_FILL_WARNING_CLOSE:
      case BfxDialogCommand.DIALOG_ORDER_CANCEL_WARNING_CLOSE:
      case BfxDialogCommand.DIALOG_ORDER_CANCEL_CONFIRM_CLOSE:
      case BfxDialogCommand.DIALOG_ORDER_ACCEPT_INTO_CLOSE:
      case BfxDialogCommand.DIALOG_TRADE_CANCEL_CONFIRM_CLOSE:
      case BfxDialogCommand.DIALOG_TRADE_ADD_FILL_COMMENT_CLOSE:
      case BfxDialogCommand.DIALOG_GENERIC_CONFIRM_CLOSE:
      case BfxDialogCommand.DIALOG_CSV_EXPORT_CLOSE:
      case BfxDialogCommand.DIALOG_FILTER_COPY_CLOSE:
      case BfxDialogCommand.DIALOG_FILTER_NEW_CLOSE:
      case BfxDialogCommand.DIALOG_FILTER_DELETE_CLOSE:
      case BfxDialogCommand.DIALOG_GENERIC_OK_CLOSE:
      case BfxDialogCommand.DIALOG_CLOSE:
      case BfxDialogCommand.DIALOG_FWD_ROLL_SAVE_ABORT_CLOSE:
      case BfxDialogCommand.DIALOG_CHANGE_PASSWORD_CLOSE:
        /* case BfxDialogCommand.DIALOG_ORDER_ENTRY_CONFIRM_ABORT_CLOSE:
			case BfxDialogCommand.DIALOG_MODIFY_CONFIRM_ABORT_CLOSE: */
        if (dialogId != null && dialogId.length > 1 && this.dialogsMap.has(dialogId)) {
          this.dialogsMap.get(dialogId).instance.closeDialog();
          //this.closeDialog(dialogId);
        } else {
          this.logCommandHandlerError("missing-dialogId", _dialogData);
        }
        break;

      /* CLOSE DIALOGS - Internal */
      case BfxDialogCommand.DIALOG_CLOSE_INTERNAL:
        if (dialogId != null && dialogId.length > 1) {
          this.closeDialog(dialogId);
        } else {
          this.logCommandHandlerError("missing-dialogId", _dialogData);
        }
        break;
      /* CLOSE ALL DIALOGS */
      case BfxDialogCommand.DIALOG_KILL_ALL:
        this.closeAllDialogs();
        break;
      default:
        logger.out.error("dialco-s: ERROR: command not implemented! command=", _dialogData);
        break;
    }
  }

  private doAutoHedgeStatusChangeDialog(dialogId: string, _dialogData: BfxDialogData): string {
    dialogId = this.isDialogIdValid(dialogId) ? dialogId : this.createDialogId("ahsc-");
    this.dialogsMap.set(
      dialogId,
      this.injectOrderDialogComponent<BfxAutoHedgeStatusChangeComponent>(
        BfxAutoHedgeStatusChangeComponent,
      ),
    );
    this.openDialogAttachSubscription(dialogId, _dialogData);
    return dialogId;
  }

  private isDialogIdValid(dialogId: string): boolean {
    return typeof dialogId === "string" && dialogId.length > 4 && !this.dialogsMap.has(dialogId);
  }

  private createDialogId(prefix: string): string {
    if (typeof prefix !== "string" || prefix.length < 3) {
      prefix = "generic";
    }
    let dialogId: string;
    do {
      dialogId = prefix + ++this.dialogCounter;
    } while (!this.isDialogIdValid(dialogId));
    return dialogId;
  }

  /**********************************************************************/
  /*  HELPERS */

  private closeAllDialogs(): void {
    this.dialogsMap.forEach((dialogSubscription: any, key: string) => {
      this.closeDialog(key);
    });
  }

  private closeDialog(_dialogId: string): void {
    logger.out.info(`dialco-s: Closing dialog with id ${_dialogId}`);
    if (this.dialogSubscriptionMap.has(_dialogId)) {
      this.dialogSubscriptionMap.get(_dialogId).unsubscribe();
      this.dialogSubscriptionMap.delete(_dialogId);
    }
    if (this.dialogsMap.has(_dialogId)) {
      try {
        this.dialogsMap.get(_dialogId).destroy();
      } catch (e) {
        logger.out.warn(`dialco-s: closeDialog(${_dialogId}) destroy() call failed %o:`, e);
        console.warn(e.stack);
      }
      this.dialogsMap.delete(_dialogId);
    }
  }

  private logCommandHandlerError(type: string, _dialogData: BfxDialogData): void {
    switch (type) {
      case "missing-dialogId":
        logger.out.error(
          "dialco-s: dialogCommandHandler(): Can not execute command: " +
            _dialogData.command +
            " for dialogId: " +
            _dialogData.dialogId,
        );
        break;
    }
  }

  private openDialogAttachSubscription(_dialogId: string, _dialogData: BfxDialogData): void {
    const command: BfxDialogCommand = _dialogData.command;
    const commandName = command ? BfxDialogCommand[command] : "<Unknown>";

    logger.out.info(`dialco-s: Opening ${commandName}, id: ${_dialogId}`);
    this.dialogSubscriptionMap.set(
      _dialogId,
      this.dialogsMap
        .get(_dialogId)
        .instance.openDialog(
          new BfxDialogData(
            command,
            _dialogId,
            _dialogData.event,
            _dialogData.payload,
            _dialogData.body,
          ),
        )
        .subscribe((_localDialogData: BfxDialogData) => {
          const retCommand: BfxDialogCommand = _localDialogData?.command;
          const retCommandName = retCommand ? BfxDialogCommand[retCommand] : "<Unknown>";
          logger.out.info(
            `dialco-s: Response callback for ${commandName}, id: ${_dialogId} - response= ${retCommandName}`,
          );
          this.dialogCommandHandler(_localDialogData);
        }),
    );

    this.dialogsMap.get(_dialogId).instance.postOpenDialog(_dialogData);
  }

  private injectOrderDialogComponent<T extends BfxDialogBaseComponent>(
    dialog: Type<T>,
  ): ComponentRef<T> {
    const factory = this.factoryResolver.resolveComponentFactory(dialog);
    const component = factory.create(this.rootViewContainer.parentInjector);

    this.rootViewContainer.insert(component.hostView);
    return component;
  }
}
